import React, {Fragment, useContext} from 'react';
import Footer from "../components/Footer";
import Header from "../components/Header";
import {Link} from 'react-router-dom';
import FormModal from "../components/FormModal";
import LangContext from "../providers/LangContext";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimesCircle} from "@fortawesome/pro-light-svg-icons/faTimesCircle";

const HeaderFooterHOC = (WrappedComponent, containerClassName) => {
    return class extends React.Component {
        static contextType = LangContext;
        render() {
            const lang = this.context.lang;
            let BiddingModalComponent = this.props.biddingForms[this.props.country];

            return(
                <Fragment>
                    <div className="column-full-height">
                        <Header
                            title={this.props.title}
                            subTitle={this.props.page.title}
                            background_image={this.props.page.background_image}
                            background_image_id={this.props.page.background_image_id}
                            fallbackBackgroundImage={this.props.fallbackBackgroundImage}
                            siteID={this.props.siteID}
                            images={this.props.images}
                        />
                        <div className={"container content " + containerClassName}>
                            <WrappedComponent {...this.props} />
                        </div>
                        <Footer
                            footerHtmlText={this.props.footerHtmlText}
                            online_bidding={this.props.online_bidding}
                            theme={this.props.theme}
                        />
                    </div>

                    {this.props.online_bidding != '0' &&
                        <FormModal
                            formTitle={lang.get('sites.bidding_modal_header')}
                            renderModal={this.props.renderModal}
                            btnText={lang.get("sites.bidding_modal_btn")}
                            formContent={<BiddingModalComponent online_bidding={this.props.bidding} className={''} terms={this.props.terms} theme={'light'} formContent={BiddingModalComponent} customBiddingFormText={this.props.customBiddingFormText} siteID={this.props.siteID}/>}
                        />
                    }

                    {this.props.property_value_report === 1 &&
                        <div className="card bg-light mb-3" style={{position: 'fixed', right: '15px', bottom: '51px', zIndex: 999, maxWidth: '240px'}}>
                            <span className="text-right pr-2 pt-2 mb-0" style={{cursor: 'pointer'}}><FontAwesomeIcon icon={faTimesCircle} onClick={this.props.togglePropValRep} /></span>
                            <div className="card-body pt-0">
                                <p className="card-title mb-2" style={{fontSize: '18px', fontWeight: 'strong'}}>Wat is mijn woning waard?</p>
                                <p className="card-text">Ontvang direct een gratis woningwaarde indicatie.</p>
                                <Link to={'woningwaarde'} className="btn btn-primary btn-block woningwaarde-check">Doe de gratis check</Link>
                            </div>
                        </div>
                    }
                </Fragment>
            )
        }
    }
};

export default HeaderFooterHOC;
